import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

//----- store
import { fetchQCardData } from "../../store/qCardTrainingHours-actions";

import IconHourGlass from "../../assets/img/icons/hour-glass.svg";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Styles from "./QCardTrainingHours.module.css";

const QCardTrainingHours = (props) => {
	const dispatch = useDispatch();

	const isLoading = useSelector((state) => state.uiData.isLoading[1]);

	const qCardTrainingHoursData = useSelector(
		(state) => state.qCardTrainingHoursData
	);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.trainingHours;

	useEffect(() => {
		dispatch(fetchQCardData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		// console.log("qCardTrainingHoursData", qCardTrainingHoursData);
	}, [qCardTrainingHoursData]);

	return (
		<div className={Styles["QCardTrainingHours"]}>
			<div className="row">
				<div className={`col-xs-12 ${Styles["title"]}`}>
					{props.title}
				</div>
			</div>
			{isLoading && (
				<div style={{ textAlign: "center" }}>
					<LoadingSpinner />
				</div>
			)}
			{!isLoading && (
				<div className={`row ${Styles["row"]}`}>
					<div className="col-xs-6">
						<span className={Styles["counter"]}>
							{qCardTrainingHoursData.value}
						</span>
					</div>
					<div className="col-xs-6">
						<span className={Styles["icon-container"]}>
							<img
								src={IconHourGlass}
								className={Styles["icon"]}
								alt=""
							/>
						</span>
					</div>
				</div>
			)}
		</div>
	);
};

export default QCardTrainingHours;
